import { useEffect } from 'react';

export default function useGameEvents({ socket, game, gameDispatch, roundDispatch }) {
  const { playerId } = game;

  useEffect(() => {
    if (!socket) return;

    // Unified state update — handles all major phase transitions
    socket.on('state-update', (dto) => {
      gameDispatch({ type: 'STATE_UPDATE', dto });
      roundDispatch({ type: 'STATE_UPDATE', dto });
    });

    // Timer ticks
    socket.on('prompt-timer', (data) => {
      roundDispatch({ type: 'PROMPT_TIMER', timeLeft: data.timeLeft });
    });

    socket.on('prompt-time-up', () => {
      roundDispatch({ type: 'PROMPT_TIME_UP' });
    });
    socket.on('response-timer', (data) => {
      roundDispatch({ type: 'RESPONSE_TIMER', timeLeft: data.timeLeft });
    });

    socket.on('response-time-up', () => {
      roundDispatch({ type: 'RESPONSE_TIME_UP' });
    });

    socket.on('voting-timer', (data) => {
      roundDispatch({ type: 'VOTING_TIMER', timeLeft: data.timeLeft });
    });

    socket.on('voting-time-up', () => {
      roundDispatch({ type: 'VOTING_TIME_UP' });
    });

    socket.on('round-countdown', (data) => {
      roundDispatch({ type: 'ROUND_COUNTDOWN', countdown: data.countdown });
    });

    socket.on('voting-complete', (data) => {
      roundDispatch({ type: 'VOTING_COMPLETE', results: data.results, judgeAward: data.judgeAward });
    });

    socket.on('controller-changed', (data) => {
      gameDispatch({
        type: 'CONTROLLER_CHANGED',
        isGameController: data.newControllerId === playerId,
        statusMessage: data.newControllerId === playerId
          ? 'You are now the Host!'
          : `${data.newControllerName} is now the Host.`,
      });
    });

    socket.on('host-disconnected', () => {
      gameDispatch({ type: 'SET_PHASE', phase: 'disconnected',
        statusMessage: 'Host disconnected. Game ended.' });
    });

    socket.on('game-reset', () => {
      gameDispatch({ type: 'SET_PHASE', phase: 'lobby', statusMessage: '' });
      roundDispatch({ type: 'RESET' });
    });

    socket.on('judge-announced', (data) => {
      roundDispatch({ type: 'JUDGE_ANNOUNCED', ...data });
    });

    return () => {
      socket.off('state-update');
      socket.off('prompt-timer');
      socket.off('prompt-time-up');
      socket.off('response-timer');
      socket.off('response-time-up');
      socket.off('voting-timer');
      socket.off('voting-time-up');
      socket.off('round-countdown');
      socket.off('voting-complete');
      socket.off('controller-changed');
      socket.off('host-disconnected');
      socket.off('game-reset');
      socket.off('judge-announced');
    };
  }, [socket, playerId, gameDispatch, roundDispatch]);
}
